import { Chain } from 'viem/chains';
import * as allChains from 'viem/chains';

import { DEFAULT_TARGET_CHAIN } from '@shared/constants';

export const getChainById = (chainId?: number): Chain => {
  const chains = Object.values(allChains) as Chain[];
  const selectedChain = chains.find((chain) => chain.id === chainId);
  return selectedChain || DEFAULT_TARGET_CHAIN;
};
